import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TRANSLATE} from '../../classes/translatable';
import {SelectionModel} from '@angular/cdk/collections';

export class FusionValidationDialogData <T>{
  fusionMessage                   = TRANSLATE("Voulez-vous vraiment fusionner les éléments");
  selection: SelectionModel<any>  = null;
  getRefToDisplay: any            = null;
  isArchive                       = false;
  isPrimary                       = false;
  buttonWording: string           = TRANSLATE('Fusionner');
}

@Component({
  selector: 'app-fusion-validation-dialog',
  templateUrl: './fusion-validation-dialog.component.html',
  styleUrls: ['./fusion-validation-dialog.component.css']
})
export class FusionValidationDialogComponent <T>implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<FusionValidationDialogComponent<T>>,
      @Inject(MAT_DIALOG_DATA) public data: FusionValidationDialogData<T> = new FusionValidationDialogData()
  ) { }

  ngOnInit() {
    if (!this.data)
      this.data = new FusionValidationDialogData();
    this.dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
